// constants for form validations

export const EMAIL_VALID_ERROR = `Enter your email address`
export const EMAIL_VALID_ERROR_2 = `We do not recognise that email address`
export const EMAIL_FORM_ERROR = `Enter your email address`
export const RESET_PASSWORD_EMAIL_ERROR = `We do not recognise that email address`
export const RESET_PASSWORD_NO_USER_OLD = 'There is no account with that username. Please check and try again, or register for a new account.'
export const RESET_PASSWORD_NO_USER = 'If there is a valid account with that username, we will have sent a password reset email to that address.'
export const USERNAME_EMPTY_ERROR = `Enter your email or phone number`
export const PHONE_FORM_ERROR = `We do not recognise that phone number`
export const PASSWORD_FORM_ERROR = `Enter your password`
export const PASSWORD_RESET_ERROR = `Please create a password`
export const PASSWORD_VALID_ERROR = `Your password must be at least 8 characters`
export const OTP_ERROR = `Enter your 6-digit reset code`
export const NAME_BLANK_ERROR_OLD = `Enter your name`
export const NAME_BLANK_ERROR = `Enter your name`
//export const NAME_BLANK_ERROR = `Name cannot be empty`
export const DATE_ERROR = `Enter your card's expiry date in the format MM/YY`
export const DATE_PAST = 'That date is in the past. Please add a card with a valid expiry date.'
export const ADDRESS_NOT_SELECT = `Please add or select your card's billing address`
export const CARD_BLANK_ERROR = `Sorry, that's not a valid card number`
export const INTERNAL_ERROR = `Sorry, something went wrong. Try again`
// Modal copy text
// If this is coming from API need to write the logic to populate that value in corresponding pages
export const CARD_DELETE_OVERLAY_HEADING = 'Do you have an Online Groceries Delivery Pass?'
export const CARD_DELETE_OVERLAY_DESCRIPTION = [
  `If you have a monthly payment plan or have enabled auto-renewal for your Delivery Pass subscription, then your Delivery Pass could be cancelled if you don't have a payment card saved to your account. To avoid this happening, either do not delete this card, or add a new card to your account as soon as possible.`,
  'You can ignore this warning message.',
  'Are you sure you want to delete your card?',
]
// constants for analytics
export const PAGE_PREFIX = `SP : `

// constants for registration

export const KICK_BOX_ERROR = `Are you sure your email address is correct?`
export const EMAIL_EXISTS_ERROR = `Looks like you already have an account! Try logging in, or you can register with a different email address.`
export const PASSWORD_BLANK_ERROR = `Create a password`
export const PASSWORD_SHORT_ERROR = `Your password must be at least 8 characters`
export const TERMS_FORM_ERROR = `Accept terms and conditions to continue`

export const POSTCODE_BLANK_ERROR = 'Enter your postcode'
export const POSTCODE_INVALID_ERROR = 'We do not recognise that postcode'
export const POSTCODE_INVALID_SERVER_ERROR = `We do not recognise that postcode`

export const WALMART_NUMBER_BLANK = `Enter your Walmart number`
export const WALMART_NUMBER_INVALID = `We do not recognise that Walmart number`

export const COLLEAGUE_CARD_BLANK = `Enter your Colleague Discount card number`
export const COLLEAGUE_CARD_INVALID = `We do not recognise that Colleague Discount number`

export const LOGIN_DISRUPTED_MSG = 'Sorry, there seems to be a problem logging you in to your account. Please contact 0330 053 0111 for help.'
export const GEORGE_PASSWORD_DISRUPTED_MSG = 'Sorry, there seems to be a problem resetting your password. Please contact 0330 053 0111 for help.'

// constants for permission centre
export const EMPTY_PREFERENCE_CHANNEL = 'Choose your preferred contact method'

// constants for perimeterX
export const PERIMETERX_MSG = 'Activate and hold the button to confirm that you\'re human. Thank You!'
